module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/superValue.d5f77440.jpg";